import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Avatar, Button, Form, Input, message, Modal, Space } from "antd";
import { Rule } from "antd/lib/form";
import { useForm } from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import { voteApi } from "api/vote.api";
import { voteAnswerApi } from "api/voteAnswer.api";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { Vote, VoteAnswer } from "types/vote";
const rules: Rule[] = [{ required: true }];

export const VoteModal = ({
  visible,
  status,
  selectData,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  status: ModalStatus;
  selectData?: Vote;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && selectData) {
      const answers = selectData.voteAnswers.map((item) => ({
        id: item?.id,
        answer: item?.name,
      }));
      form.setFieldsValue({ ...selectData, answers });
    }
  }, [visible, selectData]);

  useEffect(() => {
    if (status == "create") form.resetFields();
  }, [status]);

  const getAnswersDeleted = (answers: VoteAnswer[]) => {
    const newAnswerIds = answers.map((item) => item.id);
    const deletedAnswers = selectData?.voteAnswers.filter(
      (item) => !newAnswerIds.includes(item.id)
    );
    return deletedAnswers?.map((item) => item.id);
  };

  const handleDeleteAnswers = async (answerIds: number[]) => {
    const promiseArr = answerIds.map((item) => voteAnswerApi.delete(item));
    await Promise.all(promiseArr);
  };

  const createNewsAnswers = async (answers: VoteAnswer[], voteId: number) => {
    if (status == "update") {
      answers = answers.filter((item) => !item.id);
    }

    const promiseArr = answers.map((item: any) =>
      voteAnswerApi.create({
        voteAnswer: {
          name: item.answer,
        },
        voteId: voteId,
      })
    );

    await Promise.all(promiseArr);
  };

  const updateAnswers = async (answers: VoteAnswer[]) => {
    answers = answers.filter((item) => item.id);

    const promiseArr = answers.map((item: any) =>
      voteAnswerApi.update(item.id, {
        voteAnswer: {
          name: item.answer,
        },
        voteId: selectData?.id,
      })
    );

    await Promise.all(promiseArr);
  };

  const handleSubmitForm = async () => {
    await form.validateFields();
    setLoading(true);
    const { answers, ...dataPost } = form.getFieldsValue();

    let res: any;
    try {
      switch (status) {
        case "update":
          res = await voteApi.update(selectData?.id || 0, { vote: dataPost });

          const answerDeletedIds = getAnswersDeleted(answers);

          if (answerDeletedIds?.length) {
            await handleDeleteAnswers(answerDeletedIds);
          }
          await updateAnswers(answers);
          await createNewsAnswers(answers, res.data.id);

          message.success("Đã sửa ");
          break;

        //create
        default:
          res = await voteApi.create({ vote: dataPost });
          if (answers.length) {
            createNewsAnswers(answers, res.data.id);
          }
          message.success("Đã thêm");
          break;
      }

      onSubmitOk();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={
        (status == "create" ? "Thêm" : "Chỉnh sửa") + " nội dung bình chọn"
      }
      confirmLoading={loading}
      onOk={handleSubmitForm}
    >
      <Form form={form} layout="vertical">
        <FormItem
          rules={rules}
          required
          label="Nội dung"
          name={"shortDescription"}
        >
          <Input.TextArea
            rows={3}
            placeholder="Mô tả ngắn về câu hỏi bình chọn"
          />
        </FormItem>
        <FormItem rules={rules} required label="Tiêu đề" name={"name"}>
          <Input placeholder="Nội dung câu hỏi của bạn" />
        </FormItem>

        <Form.List name="answers">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }, index) => {
                return (
                  <Space
                    key={key}
                    style={{ display: "flex", marginBottom: 8, width: "100%" }}
                    align="baseline"
                  >
                    <Form.Item
                      {...restField}
                      name={[name, "answer"]}
                      rules={[
                        { required: true, message: "Vui lòng nhập phương án" },
                      ]}
                      style={{ width: "100%" }}
                    >
                      {/* @ts-ignore */}
                      <Input
                        style={{ width: "350px" }}
                        placeholder={`Phương án ${index + 1}`}
                      />
                    </Form.Item>
                    <MinusCircleOutlined
                      onClick={() => {
                        remove(name);
                      }}
                    />
                  </Space>
                );
              })}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  Thêm phương án
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>)
  );
};
